// @core/api/endpoints/admin/list_audit_logs_by_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditLogsResponse,
} from '../../../types/admin';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/admin';

/**
 * List audit logs for specific resource
 * Returns the complete audit history for a specific resource, showing all changes made to it over time including who made each change and when.
 */
export async function ListAuditLogsByResource(
  resource_type: string,
  resource_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditLogsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/admin/audit-logs/resource/:resource_type/:resource_id`;
  requestPath = requestPath.replace(':resource_type', encodeURIComponent(resource_type));
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<ListAuditLogsResponse>(requestPath, { ...requestOptions, params });
}
